const baseURL = "/v1/GerenciarCalendario";

const service = {
  methods: {
    $buscarCalendario(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarCalendario({ id }) {
      return this.$api().get(`${baseURL}/${id}`);
    },
    $cadastrarCalendario(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarCalendario(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $excluirEventoDiaCalendario(id, eventoCalendarioAtividadeId) {
      return this.$api().delete(`${baseURL}/ExcluirEventoCalendario/${id}/${eventoCalendarioAtividadeId}`);
    },
    $inativarAtivarCalendario(id) {
      return this.$api().patch(`${baseURL}/${id}`);
    },
    $verificarVigencia(ano) {
      return this.$api().get(`${baseURL}/VerificarVigencia/${ano}`);
    },
    $cadastrarEventoGerenciarCalendario(id, body) {
      return this.$api().post(`${baseURL}/AdicionarEventoCalendario/${id}`,
        body,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
    }

  },
};

export default service;
